import React , { useState , useEffect } from 'react'
import { ListGroupItem , Input } from 'reactstrap'


function Question_Answer_List({ ele , selected_qa, setselected_qa , checkedAll, setcheckedAll  , id , qa_list, setqa_list , enable_edit_mode }) {


    const [checked, setchecked] = useState(false)


    useEffect(() => {
      setchecked(checkedAll)
    }, [checkedAll, setchecked])

    useEffect(() => {

     
            setchecked(selected_qa.includes(ele))
        

    },[selected_qa, setselected_qa])


    const on_Select_particular = (e)=>{
         

        if(e.target.checked){
            setselected_qa([ele, ...selected_qa])
        }else{
            const temp_qa = selected_qa.filter((qa)=> qa !== ele)
            setselected_qa(temp_qa)
        }

          
    }


    const on_Delete_Particular = ()=>{

        // console.log("Calling ....");
        
        const temp_qa = qa_list.filter((element)=> element !== ele)
          setqa_list(temp_qa)        
    }
    



    



  return (
    <ListGroupItem
               
                      className="d-flex justify-content-between align-items-center"
                    >
                      <div className="chek_name">
                        <Input
                          className="form-check-input me-1"
                          type="checkbox"
                          checked={checked}
                          onChange={on_Select_particular}
                        />
                        <span className="text-muted">
                        {ele.question}
                        </span>
                      </div>
                      <span  className="dedt">
                        <span onClick={()=>{
                        enable_edit_mode(ele.question , ele.answer , ele)}}  ><i className="ri-pencil-line"></i></span>
                        <span onClick = {on_Delete_Particular}  className="red">
                          <i className="ri-delete-bin-line"></i>
                        </span>
                      </span>
                    </ListGroupItem>
  )
}

export default Question_Answer_List